import CloseIcon from '../../images/icons/close.svg?react';
import React from 'react';

type Props = {
    close: () => void;
}
const CloseButton: React.FC<Props> = ({close}) => {
    return (
        <button className="absolute right-6 top-5 flex items-center justify-center rounded-full p-1.5 text-black/40 transition-all duration-100 ease-out hover:text-black/60 dark:bg-white/15 dark:text-white/80 dark:hover:bg-white/25 dark:hover:text-white sm:right-8 sm:top-9" type="button" onClick={close}>
            <CloseIcon className="size-3.5" />
        </button>
    );
};

export default CloseButton;
